<template>
  <div
    class="user-info"
    :class="getRootClasses"
  >
    <div
      class="wrapper"
      :style="getWrapperStyles"
    >
      <img v-if="userPhoto" :src="userPhoto" class="photo">
      <p v-else>
        {{ abbreviation }}
      </p>
    </div>
    <div class="info">
      <div class="info__top">
        <div class="name">
          {{ username }}
        </div>
        <a
          v-if="canEdit"
          :href="`/update-user/${$route.params.id}`"
        >
          <BtnIcon
            icon="pencil"
            class="pencil"
          />
        </a>
      </div>
      <div class="desc">
        {{ desc }}
      </div>
    </div>
  </div>
</template>

<script>
import BtnIcon from '@/components/Base/BtnIcon'
export default {
  name: 'UserInfo',
  components: {
    BtnIcon
  },
  props: {
    canEdit: {
      type: Boolean,
      default: false
    },
    userPhoto: {
      type: String,
      default: ''
    },
    username: {
      type: String,
      default: 'Имя не указано.'
    },
    desc: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md',
      validator: val => ['md', 'lg'].includes(val)
    }
  },
  computed: {
    getRootClasses () {
      return {
        ['user-info_' + this.size]: true
      }
    },
    getWrapperStyles () {
      return {
        background: this.userPhoto ? '' : '#604681'
      }
    },
    abbreviation () {
      const username = this.username

      if (!username) {
        return ''
      }

      const parts = username.split(' ').filter(i => !!i)

      if (parts.length === 1) {
        return parts[0][0].toUpperCase()
      }

      const first = parts[0] ?? null
      const second = parts[1] ?? null

      return first[0].toUpperCase() + ' ' + second[0].toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
$brand-color:                 #FF7A00 !default;

.user-info {
  display: flex;

  &_md {
    .wrapper {
      width: 40px;
      height: 40px;
    }

    .info {
      margin-left: 10px;
    }

    .name {
      font-size: 16px;
      line-height: 20px;
      color: $brand-color;
    }

    .desc {
      font-size: 14px;
      line-height: 17px;
    }
  }
  &_lg {
    .wrapper {
      width: 60px;
      height: 60px;
    }

    .name {
      font-weight: bold;
      font-size: 28px;
      line-height: 35px;
      color: #fff;
    }

    .info {
      margin-left: 20px;
    }

    .desc {
      //margin-top: 8px;
      font-size: 16px;
    }
  }

  .wrapper {
    border-radius: 1000px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .info {
    &__top {
      display: flex;
      align-items: center;

      .pencil {
        margin-left: 10px;
      }
    }
  }

  .photo {
    display: block;
    max-width: 100%;
  }

  .desc {
    color: #9494A8;
  }
}
</style>
